import Http from '@/common/http'
export default class Auth {
  static getUserInfo (param = {}) {
    return Http.post('/home/user/get_user_info', param)
  }

  
  static getSignature (param = {}) {
    return Http.post('/home/no_auth/get_wx_h5_js_sdk_signature', param)
  }
}
